import { track } from '@amplitude/unified'
import React, { useEffect } from 'react'
import Footer from '../Partials/Footer'
import Header from '../Partials/Header'
import OurTeam from './OurTeam'

const values=[
    {
        title:"Customers",
        image:"/images/customers.png",
        colour:"#ec6c59",
        description:"We put our users at the centre of every decision, designing solutions that deliver real, lasting value.",
    },
    {
        title:"Excellence",
        image:"/images/excellence.png",
        colour:"#30a79d",
        description:"We strive for the highest standards in our people, products, and partnerships to achieve outstanding outcomes.",
    },
    {
        title:"Integrity",
        image:"/images/integrity.png",
        colour:"#07314e",
        description:"We operate with honesty and transparency, building trust through every interaction and decision.",
    },
    {
        title:"Creativity",
        image:"/images/creativity.png",
        colour:"#ed7562",
        description:"We embrace fresh thinking and emerging technologies to solve complex challenges and shape the future of solar.",
    },
]

export default function AboutUs(){
    useEffect(() => {
        track('Page Viewed', { pageName: 'About Us' });
    }, []);

    return(
        <div>
            <Header />
            <section className='about' id='about'>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center flex-column">
                            <div className="about__header">
                                <h2>About Rishi</h2>
                            </div>
                            <div className="about__paragraph mt-4">
                                <p>Established in 2022 our Rishi Tech founder started this exciting boutique technology firm with a razor-sharp focus on the utility-scale solar industry.
                                <br/><br/>Our primary goal is to leverage the latest digital technologies to reduce costs, accelerate installation and improve quality of the construction and operation of large solar power plants.
                                <br/><br/>We take pride in enhancing our products with inputs directly from our customers in the field.
                                </p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="about__img">
                                <img src="/images/about1.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='container'>
                <div data-aos-delay="6" data-aos="fade-right">
                    <img alt="vision" data-aos="fade-right" width={400} height={400} src="/images/vision.png" style={{ position: "absolute",transform: "translate(-40%, -50%)",zindex: -1,opacity: 0.2,zIndex:-2}} />
                </div>
                <div data-aos="zoom-out" style={{backgroundColor:"#ffffff"}} className="surya--box">
                    <div className="flex-container">
                        <h2 data-aos="fade-down-right" data-aos-offset="1" data-aos-delay="5"  data-aos-duration="300" className='left_header'>Vision</h2>
                        <div data-aos="fade-down-left" data-aos-offset="1" data-aos-delay="5"  data-aos-duration="300" className='right_text'>To <span className='hil'>lead the digital transformation</span> of utility-scale solar construction, <span className='hil'>empowering the industry</span> to build <span className='hil'>faster</span>, <span className='hil'>smarter</span>, and <span className='hil'>more sustainably</span>.</div>
                    </div>
                    <div className="flex-container">
                        <h2 data-aos="fade-up-right" data-aos-offset="1"  data-aos-delay="5"  data-aos-duration="300" className='left_header'>Mision</h2>
                        <div data-aos="fade-up-left" data-aos-offset="1"  data-aos-delay="5"  data-aos-duration="300" className='right_text'>We deliver <span className='hil'>trusted</span>, <span className='hil'>high-impact software solutions</span> that <span className='hil'>streamline solar farm construction</span>, <span className='hil'>reduce costs</span>, and <span className='hil'>elevate quality</span> — by combining excellence in people, integrity in service, customer-first thinking, and creative innovation.</div>
                    </div>
                </div>
                <div data-aos-delay="6"  data-aos="fade-left" style={{display:"flex", justifyContent:"right"}} >
                    <img alt="mission" width={300} height={300} src="/images/mission.png" style={{ position: "absolute",transform: "translate(40%, -50%)",zindex: -1,opacity: 0.2,zIndex:-2}} />
                </div>
                <div style={{marginTop:"40px",backgroundColor:"#ffffff"}} className="surya--box">
                    <div className='flex-container'>
                        {values.map((ele,index)=>{
                            return(<div style={{display:"flex",flexDirection:"column",padding:"2%",maxWidth:"300px"}} key={index}>
                                <img alt={ele.title} width="100vh" height="100vh" src={ele.image}/>
                                <h3 style={{color:ele.colour}}>{ele.title}</h3>
                                <p  data-aos="fade-up" data-aos-offset="3"  data-aos-delay={(index*50)+50}  data-aos-duration="500" >{ele.description}</p>
                            </div>)
                        })}
                    </div>
                </div>
            </section>
            <section id="our-team">
                <OurTeam/>
            </section>
            <Footer/>
        </div>
    )
}